import { N as push, Q as attr_class, P as pop, T as stringify, V as spread_attributes, W as clsx, X as spread_props, Y as bind_props, Z as getContext, _ as escape_html, O as setContext, $ as copy_payload, a0 as assign_payload, a1 as attr } from "../../chunks/index.js";
import clsx$1 from "clsx";
import { g as getTheme, t as toolbarButton, d as dropdownGroup, a as dropdown, n as navbarContainer, b as navbar, c as navbarBrand, e as navbarLi, f as navbarUl, h as navbarHamburger } from "../../chunks/theme.js";
import * as dom from "@floating-ui/dom";
function html(value) {
  var html2 = String(value);
  var open = "<!---->";
  return open + html2 + "<!---->";
}
function ADAFooter($$payload) {
  $$payload.out += `<footer class="ada-footer" role="contentinfo" aria-label="Accessibility Information"><div class="container"><div class="header"><img src="media/ada/ada.svg" alt="Accessibility Icon" class="ada-icon"/> <h2>Accessibility Statement</h2></div> <div class="content"><p>We are committed to ensuring digital accessibility for people with disabilities. We are
				continually improving the user experience for everyone and working to apply relevant
				accessibility standards.</p> <p>Our website is currently undergoing updates to improve accessibility and align more closely
				with the Web Content Accessibility Guidelines (WCAG). While we strive to make our website
				accessible, some content, features, or functionality may not yet be fully accessible to all
				users.</p> <p>If you experience difficulty accessing any part of this website or require an accommodation,
				please contact us and we will work with you to provide the information, product, or service
				you need through an alternative method.</p> <div class="contact-section"><h3>Contact for Accessibility Assistance</h3> <ul><li><strong>Email:</strong> <a href="mailto:cindy@officialartisanfairs.com">cindy@officialartisanfairs.com</a></li> <li><strong>Phone:</strong> (562) 338-1618</li> <li><strong>Business Hours:</strong> Monday to Thursday, 9 AM to 5 PM</li></ul></div> <p>When contacting us, please describe the accessibility issue you encountered and the best way
				to contact you. We will make reasonable efforts to respond promptly and provide an
				accessible solution.</p></div></div></footer>`;
}
const linear = (x) => x;
function cubic_out(t) {
  const f = t - 1;
  return f * f * f + 1;
}
function fade(node, { delay = 0, duration = 400, easing = linear } = {}) {
  const o = +getComputedStyle(node).opacity;
  return {
    delay,
    duration,
    easing,
    css: (t) => `opacity: ${t * o}`
  };
}
function slide(node, { delay = 0, duration = 400, easing = cubic_out, axis = "y" } = {}) {
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const primary_property = axis === "y" ? "height" : "width";
  const primary_property_value = parseFloat(style[primary_property]);
  const secondary_properties = axis === "y" ? ["top", "bottom"] : ["left", "right"];
  const capitalized_secondary_properties = secondary_properties.map(
    (e) => (
      /** @type {'Left' | 'Right' | 'Top' | 'Bottom'} */
      `${e[0].toUpperCase()}${e.slice(1)}`
    )
  );
  const padding_start_value = parseFloat(style[`padding${capitalized_secondary_properties[0]}`]);
  const padding_end_value = parseFloat(style[`padding${capitalized_secondary_properties[1]}`]);
  const margin_start_value = parseFloat(style[`margin${capitalized_secondary_properties[0]}`]);
  const margin_end_value = parseFloat(style[`margin${capitalized_secondary_properties[1]}`]);
  const border_width_start_value = parseFloat(
    style[`border${capitalized_secondary_properties[0]}Width`]
  );
  const border_width_end_value = parseFloat(
    style[`border${capitalized_secondary_properties[1]}Width`]
  );
  return {
    delay,
    duration,
    easing,
    css: (t) => `overflow: hidden;opacity: ${Math.min(t * 20, 1) * opacity};${primary_property}: ${t * primary_property_value}px;padding-${secondary_properties[0]}: ${t * padding_start_value}px;padding-${secondary_properties[1]}: ${t * padding_end_value}px;margin-${secondary_properties[0]}: ${t * margin_start_value}px;margin-${secondary_properties[1]}: ${t * margin_end_value}px;border-${secondary_properties[0]}-width: ${t * border_width_start_value}px;border-${secondary_properties[1]}-width: ${t * border_width_end_value}px;min-${primary_property}: 0`
  };
}
function Arrow($$payload, $$props) {
  push();
  let {
    placement = "top",
    cords,
    strategy = "absolute",
    class: className = ""
  } = $$props;
  $$payload.out += `<div${attr_class(`popover-arrow clip pointer-events-none block h-[10px] w-[10px] border-b border-l border-inherit bg-inherit text-inherit ${stringify(className)}`)}></div>`;
  pop();
}
function Popper($$payload, $$props) {
  push();
  let {
    triggeredBy,
    triggerDelay = 200,
    trigger = "click",
    placement = "top",
    offset = 8,
    arrow = false,
    yOnly = false,
    strategy = "absolute",
    reference,
    middlewares = [dom.flip(), dom.shift()],
    onbeforetoggle: _onbeforetoggle,
    ontoggle: _ontoggle,
    onclose: _onclose,
    class: className = "",
    arrowClass = "",
    isOpen = false,
    transitionParams,
    transition = fade,
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let arrowParams = { placement, cords: { x: 0, y: 0 }, strategy };
  $$payload.out += `<div hidden></div> `;
  if (isOpen) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div${spread_attributes(
      {
        popover: "manual",
        role: "tooltip",
        class: clsx(clsx$1(className)),
        ...restProps
      },
      null,
      { "overflow-visible": true }
    )}>`;
    children($$payload);
    $$payload.out += `<!----> `;
    if (arrow) {
      $$payload.out += "<!--[-->";
      Arrow($$payload, spread_props([arrowParams, { class: arrowClass }]));
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--></div>`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]-->`;
  bind_props($$props, { isOpen });
  pop();
}
function ToolbarButton($$payload, $$props) {
  push();
  const background = getContext("background");
  let {
    children,
    color,
    name,
    "aria-label": ariaLabel,
    size,
    class: className,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("toolbarButton");
  const buttonCls = toolbarButton({
    color,
    size,
    background: !!background,
    class: clsx$1(theme, className)
  });
  if (restProps.href === void 0) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<button${spread_attributes(
      {
        type: "button",
        ...restProps,
        class: clsx(buttonCls),
        "aria-label": ariaLabel ?? name
      },
      null
    )}>`;
    if (name) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<span class="sr-only">${escape_html(name)}</span>`;
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--> `;
    children?.($$payload);
    $$payload.out += `<!----></button>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<a${spread_attributes(
      {
        ...restProps,
        class: clsx(buttonCls),
        "aria-label": ariaLabel ?? name
      },
      null
    )}>`;
    if (name) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<span class="sr-only">${escape_html(name)}</span>`;
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--> `;
    children?.($$payload);
    $$payload.out += `<!----></a>`;
  }
  $$payload.out += `<!--]-->`;
  pop();
}
function DropdownGroup($$payload, $$props) {
  push();
  let { children, class: className, $$slots, $$events, ...restProps } = $$props;
  const theme = getTheme("dropdownGroup");
  $$payload.out += `<ul${spread_attributes(
    {
      ...restProps,
      class: clsx(dropdownGroup({ class: clsx$1(theme, className) }))
    },
    null
  )}>`;
  children($$payload);
  $$payload.out += `<!----></ul>`;
  pop();
}
function Dropdown($$payload, $$props) {
  push();
  let {
    children,
    simple = false,
    placement = "bottom",
    offset = 2,
    class: className,
    activeUrl = "",
    isOpen = false,
    onclose,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("dropdown");
  const base = dropdown({ class: clsx$1(theme, className) });
  const activeUrlStore = { value: "" };
  setContext("activeUrl", activeUrlStore);
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    Popper($$payload2, spread_props([
      restProps,
      {
        placement,
        offset,
        class: base,
        get isOpen() {
          return isOpen;
        },
        set isOpen($$value) {
          isOpen = $$value;
          $$settled = false;
        },
        children: ($$payload3) => {
          if (simple) {
            $$payload3.out += "<!--[-->";
            DropdownGroup($$payload3, {
              children: ($$payload4) => {
                children($$payload4);
                $$payload4.out += `<!---->`;
              },
              $$slots: { default: true }
            });
          } else {
            $$payload3.out += "<!--[!-->";
            children($$payload3);
            $$payload3.out += `<!---->`;
          }
          $$payload3.out += `<!--]-->`;
        },
        $$slots: { default: true }
      }
    ]));
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  bind_props($$props, { isOpen });
  pop();
}
function NavContainer($$payload, $$props) {
  push();
  let {
    children,
    fluid,
    class: clasName,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("navbarContainer");
  $$payload.out += `<div${spread_attributes(
    {
      ...restProps,
      class: clsx(navbarContainer({ fluid, class: clsx$1(theme, clasName) }))
    },
    null
  )}>`;
  children?.($$payload);
  $$payload.out += `<!----></div>`;
  pop();
}
function Navbar($$payload, $$props) {
  push();
  let {
    children,
    fluid,
    navContainerClass,
    class: className,
    closeOnClickOutside = true,
    breakpoint = "md",
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("navbar");
  let navState = { hidden: true };
  setContext("navState", navState);
  setContext("breakpoint", breakpoint);
  let toggle = () => {
    navState.hidden = !navState.hidden;
  };
  $$payload.out += `<nav><div${spread_attributes(
    {
      ...restProps,
      class: clsx(navbar({ class: clsx$1(theme, className) }))
    },
    null
  )}>`;
  NavContainer($$payload, {
    fluid,
    class: clsx$1(navContainerClass),
    children: ($$payload2) => {
      children($$payload2, { hidden: navState.hidden, toggle, NavContainer });
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div></nav>`;
  pop();
}
function NavBrand($$payload, $$props) {
  push();
  let { children, class: className, $$slots, $$events, ...restProps } = $$props;
  const theme = getTheme("navbarBrand");
  $$payload.out += `<a${spread_attributes(
    {
      ...restProps,
      class: clsx(navbarBrand({ class: clsx$1(theme, className) }))
    },
    null
  )}>`;
  children?.($$payload);
  $$payload.out += `<!----></a>`;
  pop();
}
function NavLi($$payload, $$props) {
  push();
  let navState = getContext("navState");
  let navBreakpoint = getContext("breakpoint");
  let {
    children,
    onclick,
    activeClass,
    nonActiveClass,
    class: className,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("navbarLi");
  let active = navState.activeUrl ? restProps.href === navState.activeUrl : false;
  let liClass = navbarLi({
    breakpoint: navBreakpoint,
    hidden: navState.hidden,
    class: clsx$1(
      active ? activeClass ?? navState.activeClass : nonActiveClass ?? navState.nonActiveClass,
      theme,
      className
    )
  });
  $$payload.out += `<li>`;
  if (restProps.href === void 0) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<button${spread_attributes({ role: "presentation", ...restProps, class: clsx(liClass) }, null)}>`;
    children?.($$payload);
    $$payload.out += `<!----></button>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<a${spread_attributes({ ...restProps, class: clsx(liClass) }, null)}>`;
    children?.($$payload);
    $$payload.out += `<!----></a>`;
  }
  $$payload.out += `<!--]--></li>`;
  pop();
}
function NavUl($$payload, $$props) {
  push();
  let navState = getContext("navState");
  let navBreakpoint = getContext("breakpoint");
  let {
    children,
    activeUrl = void 0,
    ulClass,
    slideParams,
    transition = slide,
    transitionParams,
    activeClass,
    nonActiveClass,
    respectMotionPreference = true,
    class: clasName,
    classes,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const styling = classes ?? { ul: ulClass };
  const theme = getTheme("navbarUl");
  let hidden = navState.hidden ?? true;
  let { base, ul, active, nonActive } = navbarUl({ hidden, breakpoint: navBreakpoint });
  let divCls = base({ class: clsx$1(theme?.base, clasName) });
  let ulCls = ul({ class: clsx$1(theme?.ul, styling.ul) });
  if (!hidden) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div${spread_attributes({ ...restProps, class: clsx(divCls) }, null)}><ul${attr_class(clsx(ulCls))}>`;
    children?.($$payload);
    $$payload.out += `<!----></ul></div>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<div${spread_attributes({ ...restProps, class: clsx(divCls) }, null)}><ul${attr_class(clsx(ulCls))}>`;
    children?.($$payload);
    $$payload.out += `<!----></ul></div>`;
  }
  $$payload.out += `<!--]-->`;
  bind_props($$props, { activeUrl });
  pop();
}
function Menu($$payload, $$props) {
  push();
  let {
    size = "24",
    color = "currentColor",
    variation = "outline",
    ariaLabel = "bars 3",
    class: className,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let viewBox = "0 0 24 24";
  let svgpath = "";
  $$payload.out += `<svg${spread_attributes(
    {
      xmlns: "http://www.w3.org/2000/svg",
      role: "button",
      tabindex: "0",
      width: size,
      height: size,
      class: clsx(clsx$1(className)),
      ...restProps,
      "aria-label": ariaLabel,
      fill: "none",
      viewBox,
      "stroke-width": "2"
    },
    null,
    void 0,
    void 0,
    3
  )}>${html(svgpath)}</svg>`;
  pop();
}
function NavHamburger($$payload, $$props) {
  push();
  let {
    children,
    onclick,
    menuClass,
    class: className,
    classes,
    name = "Open main menu",
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const styling = classes ?? { menu: menuClass };
  const theme = getTheme("navbarHamburger");
  const navState = getContext("navState");
  const navBreakpoint = getContext("breakpoint");
  const { base, menu } = navbarHamburger({ breakpoint: navBreakpoint });
  const toggle = (ev) => {
    navState.hidden = !navState.hidden;
  };
  ToolbarButton($$payload, spread_props([
    { name, onclick: onclick || toggle },
    restProps,
    {
      class: base({ class: clsx$1(theme?.base, className) }),
      children: ($$payload2) => {
        Menu($$payload2, { class: menu({ class: clsx$1(theme?.menu, styling.menu) }) });
      },
      $$slots: { default: true }
    }
  ]));
  pop();
}
function _layout($$payload, $$props) {
  const logo = "/media/branding/officialartisanfair/logo-transparent.webp";
  let { children } = $$props;
  $$payload.out += `<head><base href="/"/></head> `;
  Navbar($$payload, {
    class: "navbar-container",
    breakpoint: "lg",
    children: ($$payload2) => {
      NavBrand($$payload2, {
        href: "/",
        children: ($$payload3) => {
          $$payload3.out += `<img${attr("src", logo)} class="navbar-oaf-logo" alt="Official Artisan Fairs Logo"/>`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!----> `;
      NavHamburger($$payload2, {
        class: "flex justify-center items-center",
        style: "border: 1px black solid; border-radius: 15%; margin-right: 3%; height: 3rem; width: 3rem;"
      });
      $$payload2.out += `<!----> `;
      NavUl($$payload2, {
        children: ($$payload3) => {
          NavLi($$payload3, {
            class: "navbar-link-container",
            style: "width: 100%;",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Events`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          Dropdown($$payload3, {
            style: "border: 2px #336232 solid; border-radius: 1.0em; padding: 0.5em;",
            children: ($$payload4) => {
              NavLi($$payload4, {
                href: "/events?eventSeries=riverwalk-fair",
                class: "navbar-link-container",
                style: "padding: 1em; width: 20rem",
                children: ($$payload5) => {
                  $$payload5.out += `<!---->Riverwalk Fair`;
                },
                $$slots: { default: true }
              });
              $$payload4.out += `<!----> `;
              NavLi($$payload4, {
                href: "/events?eventSeries=downtown-fair",
                class: "navbar-link-container",
                style: "padding: 1em",
                children: ($$payload5) => {
                  $$payload5.out += `<!---->Downtown Fair`;
                },
                $$slots: { default: true }
              });
              $$payload4.out += `<!----> `;
              NavLi($$payload4, {
                href: "/events?eventSeries=night-fair",
                class: "navbar-link-container",
                style: "padding: 1em",
                children: ($$payload5) => {
                  $$payload5.out += `<!---->Night Fair`;
                },
                $$slots: { default: true }
              });
              $$payload4.out += `<!---->`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          NavLi($$payload3, {
            href: "https://forms.office.com/r/TeTUakNSA9",
            class: "navbar-link-container",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Become a Vendor`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          NavLi($$payload3, {
            href: "https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAANAAW3e-axUQThQSVVYVTc0WTk3MlQyM1IxMlJRRjdKSi4u",
            class: "navbar-link-container",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Request an Event`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!---->`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> <div class="page-content">`;
  children($$payload);
  $$payload.out += `<!----></div> `;
  ADAFooter($$payload);
  $$payload.out += `<!---->`;
}
export {
  _layout as default
};
